module.exports = __webpack_public_path__ + "static/media/icon_calendar_2.47dce475.svg";